function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, onMounted, reactive, ref, watch, getCurrentInstance } from "vue";
import SearchBar from "@/components/SearchV3/index.vue";
import searchMixin from "@/mixin/search";
import TableList from "@/components/TableList/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import ViewDialog from "./message/view-dialog.vue";
import { statusOptions, popUpOptions, typeOptions, triggerOptions, getOptionsLabel, planList, getPlanList } from "./index";
import StatusRecordDialog from "./message/status-record-dialog.vue";
import { format } from "date-fns";
import _ from "lodash";
import { messageList, messageUpdate, getMessageOptions, StatusType, MeaasgeStatusType, messageDetail, messageDraft } from "@/api/message/message";
var defaultQuery = {
    title: "",
    send_time: [],
    created_time: [],
    status: "",
    sender_id: "",
    page: 1,
    page_size: 15,
    order: "-created_time"
};
export default defineComponent({
    components: {
        SearchBar: SearchBar,
        TableList: TableList,
        Pagination: Pagination,
        ViewDialog: ViewDialog,
        StatusRecordDialog: StatusRecordDialog
    },
    mixins: [
        searchMixin
    ],
    setup: function setup(props) {
        var viewContent = function viewContent(content) {
            viewDialog.visible = true;
            viewDialog.content = content;
        };
        var viewAdv = function viewAdv(msg_id, status) {
            statusRecordDialog.msg_id = msg_id;
            statusRecordDialog.status = status;
            statusRecordDialog.visible = true;
        };
        var initQuery = function initQuery(row) {
            var zhOption = row.message_langs.find(function(s) {
                return s.lang === "zh-cn";
            });
            var enOption = row.message_langs.find(function(s) {
                return s.lang === "en";
            });
            var query = _objectSpreadProps(_objectSpread({}, _.pick(row, [
                "trigger",
                "type",
                "send",
                "is_pop_up"
            ])), {
                send: "immediate",
                trigger_value: row.trigger_value ? row.trigger_value.split(",").map(Number) : [],
                lang: (zhOption === null || zhOption === void 0 ? void 0 : zhOption.lang) ? "zh" : enOption === null || enOption === void 0 ? void 0 : enOption.lang,
                zh_title: zhOption === null || zhOption === void 0 ? void 0 : zhOption.title,
                zh_content: zhOption === null || zhOption === void 0 ? void 0 : zhOption.content,
                en_title: enOption === null || enOption === void 0 ? void 0 : enOption.title,
                en_content: enOption === null || enOption === void 0 ? void 0 : enOption.content
            });
            return query;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var list1 = ref([]);
        var loading = ref(false);
        var total = ref(0);
        var query1 = ref(defaultQuery);
        var viewDialog = reactive({
            visible: false,
            content: []
        });
        var statusRecordDialog = reactive({
            visible: false,
            msg_id: 0,
            status: MeaasgeStatusType.Read
        });
        var senderOptions = ref([]);
        onMounted(function() {
            getPlanList();
            handleMessageOptions();
            watch(function() {
                return root.$route;
            }, function(to, from) {
                if (_.isEmpty(to.query)) {
                    query1.value = _objectSpread({}, defaultQuery);
                }
                query1.value.sender_id = String(query1.value.sender_id);
                initData();
            }, {
                immediate: true
            });
        });
        var formItemList = computed(function() {
            return [
                {
                    type: "input",
                    prop: "title",
                    params: {
                        clearable: true,
                        placeholder: "\u8BF7\u8F93\u5165\u6807\u9898"
                    }
                },
                {
                    type: "select",
                    prop: "sender_id",
                    params: {
                        clearable: true,
                        placeholder: "\u8BF7\u9009\u62E9\u64CD\u4F5C\u4EBA",
                        filterable: true,
                        "collapse-tags": true,
                        options: senderOptions.value
                    }
                },
                {
                    type: "select",
                    prop: "status",
                    params: {
                        placeholder: "\u8BF7\u9009\u62E9\u72B6\u6001",
                        multiple: true,
                        clearable: true,
                        "collapse-tags": true,
                        options: statusOptions
                    }
                },
                {
                    type: "select",
                    prop: "is_pop_up",
                    params: {
                        placeholder: "\u662F\u5426\u5F39\u7A97",
                        clearable: true,
                        options: popUpOptions
                    }
                },
                {
                    type: "select",
                    prop: "type",
                    params: {
                        placeholder: "\u53D1\u9001\u89C4\u5219",
                        clearable: true,
                        options: typeOptions
                    }
                },
                {
                    type: "select",
                    prop: "trigger",
                    params: {
                        placeholder: "\u53D1\u9001\u65F6\u673A",
                        clearable: true,
                        options: triggerOptions
                    }
                },
                {
                    type: "select",
                    prop: "trigger_value",
                    params: {
                        placeholder: "\u5BF9\u5E94\u5957\u9910",
                        multiple: true,
                        filterable: true,
                        "collapse-tags": true,
                        clearable: true,
                        options: planList.value
                    }
                },
                {
                    type: "date-picker",
                    subtype: "datetimerange",
                    prop: "created_time",
                    class: "date-picker",
                    params: {
                        clearable: true,
                        format: "yyyy-MM-dd HH:mm:ss",
                        valueFormat: "yyyy-MM-dd HH:mm:ss",
                        startPlaceholder: "\u521B\u5EFA\u5F00\u59CB\u65F6\u95F4",
                        endPlaceholder: "\u521B\u5EFA\u7ED3\u675F\u65F6\u95F4",
                        pickerOptions: {
                            disabledDate: function disabledDate(time) {
                                return time.getTime() > Date.now();
                            }
                        }
                    }
                },
                {
                    type: "date-picker",
                    subtype: "datetimerange",
                    prop: "send_time",
                    class: "date-picker",
                    params: {
                        clearable: true,
                        format: "yyyy-MM-dd HH:mm:ss",
                        valueFormat: "yyyy-MM-dd HH:mm:ss",
                        startPlaceholder: "\u53D1\u9001\u5F00\u59CB\u65F6\u95F4",
                        endPlaceholder: "\u53D1\u9001\u7ED3\u675F\u65F6\u95F4"
                    }
                }, 
            ];
        });
        var tableColumnConfig = computed(function() {
            return [
                {
                    label: "\u6807\u9898",
                    slot: "message_langs"
                },
                {
                    label: "\u5185\u5BB9",
                    slot: "msg_id"
                },
                {
                    label: "\u72B6\u6001",
                    prop: "status",
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            return getOptionsLabel(row.status, statusOptions);
                        }
                    }
                },
                {
                    label: "\u662F\u5426\u5F39\u7A97",
                    prop: "is_pop_up",
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            return getOptionsLabel(row.is_pop_up, popUpOptions);
                        }
                    }
                },
                {
                    label: "\u53D1\u9001\u89C4\u5219",
                    prop: "type",
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            return getOptionsLabel(row.type, typeOptions);
                        }
                    }
                },
                {
                    label: "\u53D1\u9001\u65F6\u673A",
                    prop: "trigger",
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            return getOptionsLabel(row.trigger, triggerOptions);
                        }
                    }
                },
                {
                    label: "\u5BF9\u5E94\u5957\u9910",
                    prop: "trigger_value",
                    width: 127,
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            if (row.trigger_value !== "") {
                                var triggerValueArray = planList.value.filter(function(s) {
                                    return row.trigger_value.split(",").map(Number).includes(s.value);
                                });
                                return _.map(triggerValueArray, "label").join();
                            }
                            return "-";
                        }
                    }
                },
                {
                    label: "\u5DF2\u8BFB/\u53D1\u9001",
                    slot: "read_count"
                },
                {
                    label: "\u521B\u5EFA\u65F6\u95F4",
                    prop: "created_time",
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            return format(row.created_time * 1000, "YYYY/MM/DD HH:mm:ss");
                        }
                    }
                },
                {
                    label: "\u53D1\u9001\u65F6\u95F4",
                    prop: "send_time",
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            return row.send_time ? format(row.send_time * 1000, "YYYY/MM/DD HH:mm:ss") : "-";
                        }
                    }
                },
                {
                    label: "\u64CD\u4F5C\u4EBA",
                    prop: "sender_name",
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            return row.sender_name || "-";
                        }
                    }
                },
                {
                    slot: "action-cell"
                }, 
            ];
        });
        function initData() {
            return _initData.apply(this, arguments);
        }
        function _initData() {
            _initData = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var innerParams, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            innerParams = _objectSpread({}, query1.value);
                            if (!_.isEmpty(innerParams.created_time)) {
                                innerParams.created_start_time = innerParams.created_time[0];
                                innerParams.created_end_time = innerParams.created_time[1];
                                innerParams = _.omit(innerParams, [
                                    "created_time"
                                ]);
                            }
                            if (!_.isEmpty(innerParams.send_time)) {
                                innerParams.send_start_time = innerParams.send_time[0];
                                innerParams.send_end_time = innerParams.send_time[1];
                                innerParams = _.omit(innerParams, [
                                    "send_time"
                                ]);
                            }
                            loading.value = true;
                            _ctx.next = 7;
                            return messageList(innerParams);
                        case 7:
                            res = _ctx.sent;
                            loading.value = false;
                            if (!(res.status !== 200)) {
                                _ctx.next = 12;
                                break;
                            }
                            root.$message.error("\u51FA\u9519\u4E86");
                            return _ctx.abrupt("return");
                        case 12:
                            list1.value = _.get(res, "data.data.list") || [];
                            total.value = _.get(res, "data.data.total");
                            _ctx.next = 20;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](0);
                            loading.value = false;
                            console.log(_ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        16
                    ]
                ]);
            }));
            return _initData.apply(this, arguments);
        }
        function handleMessageUpdate(command, msg_id) {
            return _handleMessageUpdate.apply(this, arguments);
        }
        function _handleMessageUpdate() {
            _handleMessageUpdate = _asyncToGenerator(regeneratorRuntime.mark(function _callee(command, msg_id) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return messageUpdate({
                                command: command,
                                msg_id: msg_id
                            });
                        case 3:
                            res = _ctx.sent;
                            if (!(res.status !== 200)) {
                                _ctx.next = 7;
                                break;
                            }
                            root.$message.error("\u51FA\u9519\u4E86");
                            return _ctx.abrupt("return");
                        case 7:
                            initData();
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return _handleMessageUpdate.apply(this, arguments);
        }
        function handleMessageEdit(row) {
            return _handleMessageEdit.apply(this, arguments);
        }
        function _handleMessageEdit() {
            _handleMessageEdit = _asyncToGenerator(regeneratorRuntime.mark(function _callee(row) {
                var newQuery, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            newQuery = _objectSpread({
                                advs: "",
                                users: ""
                            }, initQuery(row));
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return messageDetail(row.msg_id);
                        case 4:
                            res = _ctx.sent;
                            newQuery.users = _.get(res, "data.data.all_users") ? "all" : "part";
                            newQuery.advs = encodeURIComponent(JSON.stringify(_.get(res, "data.data.receive_ids") || []));
                            newQuery.msg_id = row.msg_id;
                            root.$router.push({
                                name: "website.station-letter.send",
                                query: newQuery
                            });
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](1);
                            console.log(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        11
                    ]
                ]);
            }));
            return _handleMessageEdit.apply(this, arguments);
        }
        function handleMessageCopy(row) {
            return _handleMessageCopy.apply(this, arguments);
        }
        function _handleMessageCopy() {
            _handleMessageCopy = // 复制站内信
            _asyncToGenerator(regeneratorRuntime.mark(function _callee(row) {
                var newQuery, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            newQuery = _objectSpread({
                                advs: "",
                                users: ""
                            }, initQuery(row));
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return messageDetail(row.msg_id);
                        case 4:
                            res = _ctx.sent;
                            newQuery.users = _.get(res, "data.data.all_users") ? "all" : "part";
                            newQuery.advs = encodeURIComponent(JSON.stringify(_.get(res, "data.data.receive_ids") || []));
                            root.$router.push({
                                name: "website.station-letter.send",
                                query: newQuery
                            });
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](1);
                            console.log(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        10
                    ]
                ]);
            }));
            return _handleMessageCopy.apply(this, arguments);
        }
        function handleMessageSend() {
            return _handleMessageSend.apply(this, arguments);
        }
        function _handleMessageSend() {
            _handleMessageSend = // 是否有保存草稿的站内信
            _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res, list, newQuery;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return messageDraft();
                        case 3:
                            res = _ctx.sent;
                            list = _.get(res, "data.data.list") || [];
                            if (list.length) {
                                newQuery = _objectSpread({
                                    users: "all"
                                }, initQuery(list[0]));
                                root.$router.push({
                                    name: "website.station-letter.send",
                                    query: newQuery
                                });
                            } else {
                                root.$router.push({
                                    name: "website.station-letter.send"
                                });
                            }
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return _handleMessageSend.apply(this, arguments);
        }
        function handleMessageOptions() {
            return _handleMessageOptions.apply(this, arguments);
        }
        function _handleMessageOptions() {
            _handleMessageOptions = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getMessageOptions({
                                option_type: "operator"
                            });
                        case 3:
                            res = _ctx.sent;
                            if (!(res.status !== 200)) {
                                _ctx.next = 7;
                                break;
                            }
                            root.$message.error("\u51FA\u9519\u4E86");
                            return _ctx.abrupt("return");
                        case 7:
                            senderOptions.value = (_.get(res, "data.data.options") || []).map(function(item) {
                                return {
                                    value: item.value,
                                    label: item.name
                                };
                            });
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return _handleMessageOptions.apply(this, arguments);
        }
        return {
            query: query1,
            list: list1,
            loading: loading,
            total: total,
            tableColumnConfig: tableColumnConfig,
            formItemList: formItemList,
            viewDialog: viewDialog,
            statusRecordDialog: statusRecordDialog,
            StatusType: StatusType,
            MeaasgeStatusType: MeaasgeStatusType,
            initData: initData,
            viewContent: viewContent,
            viewAdv: viewAdv,
            handleMessageSend: handleMessageSend,
            handleMessageUpdate: handleMessageUpdate,
            handleMessageEdit: handleMessageEdit,
            handleMessageCopy: handleMessageCopy
        };
    }
});
